var $574581eccbeec513$exports = {};
$574581eccbeec513$exports = {
    "actions": `\xc5tg\xe4rder`,
    "hideButtonLabel": `Visa mindre`,
    "noTags": `Ingen`,
    "showAllButtonLabel": (args, formatter)=>`Visa alla (${formatter.number(args.tagCount)})`
};


export {$574581eccbeec513$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
